import { useContext, useEffect, useState } from "react";
import {
  Card,
  AuthContext,
  ViewContext,
  Loader,
  useAPI
} from "@/components/lib";
import { useForm } from "react-hook-form";
import axios from "axios";
import Styles from "@/css/mainStyles";

const ClassModal = ({ setShow, reload }: any) => {
  const viewContext = useContext<any>(ViewContext);
  const authContext = useContext<any>(AuthContext);
  const { data, loading: loadingClasses } = useAPI(
    `${authContext.remote_server}/api/settings`
  );

  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm();

  useEffect(() => {
    if (data?.data?.classYears) {
      setValue("y1", data.data.classYears.y1);
      setValue("y2", data.data.classYears.y2);
      setValue("y3", data.data.classYears.y3);
    }
  }, [data, setValue]);

  const onSubmit = async (data: any) => {
    const updateClassURL = `${authContext.remote_server}/api/settings`;

    const formData = { classYears: {} } as any;
    data.y1 && (formData.classYears.y1 = data.y1);
    data.y2 && (formData.classYears.y2 = data.y2);
    data.y3 && (formData.classYears.y3 = data.y3);

    try {
      setLoading(true);
      await axios({
        method: "patch",
        url: updateClassURL,
        data: formData
      });
      viewContext.notification.show("Classes updated!", "success");
      reload && reload();
    } catch (error) {
      console.error(error);
      viewContext.notification.show(error.message, "error");
    } finally {
      setLoading(false);
      setShow(false);
    }
  };

  return (
    <Card className="rounded-2xl md:w-[600px]">
      <div className="flex justify-between items-start">
        <h1 className="font-bold text-3xl text-black">Edit Classes</h1>
        <button onClick={() => setShow(false)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <form
        className="flex flex-col gap-2 mt-4 pr-2 pb-2"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex flex-col w-full">
          <label className="text-sm lg:text-lg font-medium text-black ml-2 mb-2">
            Class 1
          </label>
          <input
            placeholder="Class 1"
            type="text"
            disabled={loadingClasses}
            className="px-[18px] py-2 lg:py-3 rounded-full lg:text-lg w-full text-black border border-slate-300"
            {...register("y1", { required: true })}
            style={errors.y1 && { border: "1px solid red" }}
          />
        </div>
        <div className="flex flex-col w-full">
          <label className="text-sm lg:text-lg font-medium text-black ml-2 mb-2">
            Class 2
          </label>
          <input
            placeholder="Class 2"
            type="text"
            disabled={loadingClasses}
            className="px-[18px] py-2 lg:py-3 rounded-full lg:text-lg w-full text-black border border-slate-300"
            {...register("y2", { required: true })}
            style={errors.y2 && { border: "1px solid red" }}
          />
        </div>
        <div className="flex flex-col w-full">
          <label className="text-sm lg:text-lg font-medium text-black ml-2 mb-2">
            Class 3
          </label>
          <input
            placeholder="Class 3"
            type="text"
            disabled={loadingClasses}
            className="px-[18px] py-2 lg:py-3 rounded-full lg:text-lg w-full text-black border border-slate-300"
            {...register("y3", { required: true })}
            style={errors.y3 && { border: "1px solid red" }}
          />
        </div>

        <div className="flex justify-end gap-4 ml-auto mt-4 w-1/2">
          <button
            type="button"
            className={Styles.cancelButton}
            onClick={() => setShow(false)}
          >
            Cancel
          </button>

          <button type="submit" className={Styles.submitButton}>
            Update
            {(loadingClasses || loading) && <Loader />}
          </button>
        </div>
      </form>
    </Card>
  );
};

export default ClassModal;
